import ApiEndpoint, { type ApiResponse } from 'network/ApiEndpoint'
import { type FeedQueryParams } from '../types'
import { mapFeedDataFromResponse } from 'api/channel/mapFeedDataFromResponse'

export const fetchFeeds = async (
  parameters: FeedQueryParams
): Promise<ApiResponse> => {
  try {
    const response: ApiResponse = await ApiEndpoint.call({
      path: 'session/user_feed',
      params: parameters
    })
    const mapped = {
      ...response,
      data: mapFeedDataFromResponse(response.data, parameters?.channel)
    }
    return mapped
  } catch (e: unknown) {
    if (e instanceof Error) {
      console.error('Error fetching feed:', e.message)
      throw new Error(e.message)
    } else {
      console.error('Error fetching feed:', e)
      throw new Error('An unknown error occurred while fetching the feed.')
    }
  }
}
